// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3rHVL","footer":"ModalInfo_footer__184EY"};